/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';

// Material UI
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import MenuItem from '@material-ui/core/MenuItem';

class GetListOfHolidays extends React.Component {
    getHolidayList = () => {
        const { calendarResponse } = this.props;
        const holidayList = calendarResponse.shipHolidays.map((holiday) => (
            <MenuItem key={holiday.holidayCode} value={holiday.holidayCode}>
                {holiday.holidayDesc}
            </MenuItem>
        ));
        holidayList.unshift(
            <MenuItem key="NA" value="Select a holiday">
                <em>Select a holiday</em>
            </MenuItem>,
        );
        return holidayList;
    }

    handleOnChange = (event) => {
        const { onHolidaySelected } = this.props;
        onHolidaySelected(event.target.value);
    }

    render() {
        const { selectedHoliday, holidaySelected } = this.props;
        return (
            <Select
                input={(
                    <Input
                        name="holiday"
                        id="holiday"
                    />
                )}
                value={selectedHoliday || holidaySelected}
                onChange={this.handleOnChange}
                autoWidth
                style={{ marginTop: 0 }}
            >
                {this.getHolidayList()}
            </Select>
        );
    }
}

GetListOfHolidays.propTypes = {
    calendarResponse: PropTypes.object.isRequired,
    selectedHoliday: PropTypes.string.isRequired,
    holidaySelected: PropTypes.string.isRequired,
    onHolidaySelected: PropTypes.func.isRequired,
};

export default GetListOfHolidays;
